import authenticator from '../../services/authenticateService'
import { setCache, getCache } from '../../utils/commonFn'
import store from "../../services/store";
import cookie from "../cookie";

export function getDefaultOptions(method) {

    var options = {
        async: true,
        crossDomain: true,
        method: method,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    }
    if (authenticator.isLoggedIn()) {
        options.headers.Authorization ="Bearer "+cookie.getItem('authorizationKey');
    }

    return options;
}


export default async function useFetchApi(url, options, isCache = false) {

    var BASEURL = "https://www.viewprogis.com/api";
    // var BASEURL = "http://www.viewprogis.com:8880";
    //   var BASEURL = "https://localhost:44340/";
    try {
        var data = null;
        if (isCache && options.method == "GET") {
            data = getCache(url);
        }
        if (data == null || data == undefined) {
            const res = await fetch(BASEURL + url, options);
            if (res.status == 401) {
                //GetToken()
                throw res;
            }
            else if (res.status == 404) {
                throw res;
            }
            const json = await res.json();
            json.fetchStatus = res.status;
            if (isCache && options.method == "GET") {
                setCache(url, json)
            }
            return json;
        }
        else {
            return data;
        }



    } catch (error) {
        console.error(error);
        //throw error;
    }
};

export function useGet(url, isCache = false) {
    var options = getDefaultOptions('GET');
    return useFetchApi(url, options, isCache)
}


export function usePost(url, body) {
    var options = getDefaultOptions('POST');
    options.body = JSON.stringify(body)
    return useFetchApi(url, options);
}
export function useUpload(url, file, postBody) {
    const formData = new FormData();
    var dataList = postBody, key;
    var data = store.api.getJSON(store.data.USERDATA);
    var checkIsagent = data == null ? false : data.isagent
    var options = {
        method: 'POST',
        headers: {}
    }
    if (authenticator.isLoggedIn()) {
        options.headers.Authorization = cookie.getItem('authorizationKey');
    }
    if (checkIsagent) {
        options.headers.Loginfrom = "pos"
    }

    if (postBody) {
        for (key in dataList) {
            if (dataList.hasOwnProperty(key)) {
                formData.append(key, dataList[key])
            }
        }
        options.body = formData
    }
    if (file) {
        formData.append("FileName", file, file.name)
    }
    return useFetchApi(url, options);
}

function GetToken() {
    usePost("/api/LoginRegister/RefreshToken", {
        "RefreshTokenCode": authenticator.getTokenKey(),
        "TokenData": cookie.getItem('authorizationKey')

    }).then(res => {
        if (!res.errorState) {
            if (res.data) {
                authenticator.updateTokenKeys(res.data)
                window.location.href = window.location.href;
            }
        } else {
            authenticator.logout()
            // window.location.replace("/");
        }
    })
}
